export default __webpack_public_path__ + "static/media/sheeps.3898b4e3.png";